// extracted by mini-css-extract-plugin
module.exports = {"upload":"_3123","uploader":"_4595","icon":"_19964","tips":"_14199"};